<template>
  <Card class="publisher-card-view">
    <div class="publisher-card-view__cover-img-thumb clickable" v-bind:style="coverImageStyle" v-on:click="goToMyCardDetails()"></div>

    <div class="card-block clickable" v-on:click="goToMyCardDetails()">
      <h4 class="publisher-card-view__title typography--headline" v-bind:title="card.title">
        {{ card.title }}
      </h4>

      <div class="typography--caption">
        {{ getGradeLabel(card) }} ∙
        {{ getSubjectLabel(card) }}
        <span v-if="card.chapter_name">
          ∙ {{ card.chapter_name }}
        </span>
        <span v-else-if="!isEmpty(card.core_concept)">
          ∙ {{ getCoreConceptLabel(card.core_concept) }}
        </span>
      </div>

      <div class="mt-16">
        <small class="typography--caption typography--color-secondary">
          <span v-if="(card.page_count - card.quiz_count) > 0">
            {{ $t('common.card.non_quiz') }} {{ $t('common.card.count', { cnt: card.page_count - card.quiz_count }) }}
          </span>
          <span v-if="(card.page_count - card.quiz_count) > 0 && card.quiz_count > 0">∙</span>
          <span v-if="card.quiz_count > 0">
            {{ $t('common.card.quiz') }} {{ $t('common.card.count', { cnt: card.quiz_count }) }}
          </span>
          <span v-else style="color: transparent">_</span>
        </small>
      </div>

      <div>
        <small class="typography--caption typography--color-secondary">
          {{ $t('series_cards.meta.card_price', { price: cardPrice }) }}
        </small>
      </div>

      <div>
        <small class="typography--caption typography--color-secondary">
          <strong>{{ getShareLevelLabel(card.share_level) }}</strong>
        </small>
      </div>

      <div>
        <small class="typography--caption typography--color-secondary">
          {{ $t('common.card.updated_at') }}: {{ card.updated_at | datetime }}
        </small>
      </div>
    </div>

    <div class="publisher-card-view__action">
      <div class="float-right" v-if="isSeriesCard">
        <IconDropdown v-bind:dropup="true">
          <b-dropdown-item class="dropdown-item" v-on:click="$emit('open-remove-from-series-modal', card.id)">
            {{ $t('publishers.card.remove_from_series') }}
          </b-dropdown-item>

          <b-dropdown-item class="dropdown-item" v-on:click="$emit('open-remove-card-modal', card.id)" v-if="isCardAuthor">
            {{ $t('common.card.menu.remove') }}
          </b-dropdown-item>
        </IconDropdown>
      </div>

      <button class="btn btn-inverted-primary" v-on:click="$emit('open-add-to-series-modal', card.id)" v-else>
        {{ $t('publishers.card.add_to_series') }}
      </button>
    </div>
  </Card>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { isNil, isEmpty } from 'lodash';
  import labels from '@/mixins/labels';

  export default {
    name: 'publisher-card-view',

    mixins: [
      labels,
    ],

    props: {
      card: {
        type: Object,
        default: null,
      },
      isSeriesCard: {
        type: Boolean,
        default: true,
      },
    },

    computed: {
      ...mapGetters([
        'subjectMap',
        'gradeMap',
      ]),

      coverImageStyle() {
        if (this.card && this.card.cover_image_small) {
          return {
            'background-image': `url('${this.card.cover_image_small}')`,
          };
        }

        return {};
      },

      isCardAuthor() {
        if (this.card && this.card.author_id) {
          return true;
        }

        return false;
      },

      cardPrice() {
        if (this.card && !isNil(this.card.price)) {
          return this.card.price;
        }

        return '-';
      },
    },

    methods: {
      goToMyCardDetails() {
        this.$router.push(`/my-cards/${this.card.id}`);
      },

      isEmpty,
    },
  };
</script>

<style lang="scss">
  .publisher-card-view {
    .publisher-card-view__cover-img-thumb {
      height: 144px;
      background-color: #f7f7f7;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      @media (max-width: 575px) {
        height: 200px;
      }
    }

    .publisher-card-view__title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; /* number of lines to show */
      max-height: 1.5em;    /* fallback */
      margin-bottom: 8px;
    }

    .publisher-card-view__action {
      padding: 8px;
      border-top: 1px solid #e6e6e6;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/publishers/components/PublisherCardView.vue